var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.Bankruptcy === 'T')?_c('div',{attrs:{"id":"bankruptcy"}},[_c('h3',{staticClass:"h4"},[_vm._v("Bankruptcy Information")]),_c('pre',[_vm._v(_vm._s(_vm.item.BankruptcyNotes))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }